import type {ToolUserRequestedMessage} from '../../types/session'
import {isPermissionRequestArguments} from '../../types/session'
import {ResolvedPermission} from './ResolvedPermission'
import {DENIED_RESULT_KINDS} from '../../utils/events/permission-constants'

function isDeniedResult(resolvedAnswer: string | undefined): boolean {
  if (!resolvedAnswer) return false
  return DENIED_RESULT_KINDS.has(resolvedAnswer)
}
interface PermissionLogEntryProps {
  prompt: ToolUserRequestedMessage
  resolvedAnswer?: string
  isAborted?: boolean
}

/** Renders a resolved permission_request prompt in the session logs timeline. */
export function PermissionLogEntry({prompt, resolvedAnswer, isAborted}: PermissionLogEntryProps) {
  const {arguments: args} = prompt

  if (!isPermissionRequestArguments(args)) {
    return null
  }

  const effectiveDenialKind = isAborted && !resolvedAnswer ? 'aborted-by-user' : resolvedAnswer
  if (!isDeniedResult(effectiveDenialKind)) {
    return null
  }

  let detail = args.command || args.filePath || args.diff
  if (!detail && args.kind === 'hook' && args.toolArgs) {
    const toolLabel = args.toolName || args.kind || 'unknown'
    detail = `Tool: ${toolLabel}\nArgs: ${args.toolArgs}`
  }

  return (
    <ResolvedPermission
      kind={args.kind}
      toolName={args.toolName}
      serverName={args.serverName}
      description={args.description}
      detail={detail}
      denialKind={effectiveDenialKind}
    />
  )
}
